/**
 * Built-in UI component registrations (side-effect imports).
 * @see docs/repo-modularity.md
 */
import './controls';
import './overlays';
import './navigation';
import './dataViews';
